import { ChangeEvent, forwardRef } from 'react';
import { Input } from '@components/input';
import { InputProps } from '@components/input/input-text.type';

export const InputUrlSimple = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const cleanValue = value.replace(/^https?:\/\//i, '').trim();

    const newEvent = {
      ...e,
      target: {
        ...e.target,
        value: cleanValue,
      },
    } as ChangeEvent<HTMLInputElement>;

    props.onChange?.(newEvent);
  };

  return <Input {...props} ref={ref} onChange={handleChange} />;
});

InputUrlSimple.displayName = 'InputUrlSimple';
